import { render, staticRenderFns } from "./DaftarGadaiAktif.vue?vue&type=template&id=302136b0&"
import script from "./DaftarGadaiAktif.vue?vue&type=script&lang=js&"
export * from "./DaftarGadaiAktif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports